module.exports = __webpack_public_path__ + "static/hero_mobile-ef9862e0339f4cee1daee0cfaf362fbf.svg";